import { defaultTrackingProps } from '@thriveglobal/thrive-web-tracking'

/**
 * Returns default tracking properties including system-level defaults.
 *
 * @template T - The type of tracking properties.
 * @param {Partial<T>} overrides - Optional properties to override the defaults.
 * @returns {T} - The merged default and overridden tracking properties.
 */
const getDefaultTrackingProps = <T extends object>(
    overrides?: Partial<T>
): T => {
    return {
        ...defaultTrackingProps,
        ...{
            isSystemEvent: false
        },
        ...overrides
    } as T
}

/**
 * Merges default tracking properties with any additional properties.
 *
 * @template T - The type of the tracking properties.
 * @param {Partial<T>} props - Partial tracking properties to override the defaults.
 * @returns {T} - The merged tracking properties.
 */
const getTrackingProps = <T extends object>(props: Partial<T>): T => {
    return getDefaultTrackingProps<T>(props)
}

export default getTrackingProps
